import { SVGProps, Ref, forwardRef } from 'react';

export const MicFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M7.998.502c-1.666 0-3.333.834-3.333 3.333v3.332c0 2.5 1.667 3.333 3.333 3.333s3.332-.833 3.332-3.333V3.835c0-2.5-1.666-3.333-3.332-3.333"
                fill="currentColor"
            />
            <path
                d="M1.996 7.9c.383 3.412 2.76 4.768 5.302 4.971V14.1h-2.67v1.4h6.666v-1.4H8.698V12.87C11.24 12.668 13.616 11.312 14 7.9h-1.41c-.178 1.3-.705 2.1-1.32 2.607-.805.665-1.963.992-3.272.992s-2.467-.327-3.273-.992C4.111 10 3.584 9.2 3.406 7.9z"
                fill="currentColor"
            />
        </g>
    </svg>
));
MicFilledSize16Glyph.displayName = 'MicFilledSize16Glyph';
